/**
 * @file 領域 (9個) ごとのアクセント色をトークンの名前で引く。
 *
 * @what: 到達度モデルの domain id → カードの縁・ドットに使う CSS のトークン参照
 *   (`var(--study-domain-...)`)。実際の値は shared/ui/studyTheme.css がライトとダークの
 *   両方で持つ。並び順はモデルの領域順に固定で割り当てる (順番を変えると隣り合うカードの
 *   色差の保証が崩れる)。
 * @why: スタディ面は情報の判別のために色を多用する方針 (2026-08-20 代表)。9色は
 *   色覚多様性 (CVD) の分離と明度帯を検証済みのカテゴリカルパレット。色はあくまで
 *   補助で、領域名のテキストラベルを常に併記する (色だけで識別させない)。値を CSS 側に
 *   置くのは、ダークで暗い面に沈む色を差し替えられるようにするためである。
 * @failure: モデルに新しい領域を足したらここと studyTheme.css の両方に追記する。漏れは
 *   tests/study/domainColors.test.ts が検出し、画面上は無彩色 (border 色) に縮退する。
 */

export const DOMAIN_IDS = [
  "fine_motor",
  "craft",
  "shape_space",
  "number",
  "language",
  "listening_memory",
  "reasoning_knowledge",
  "body",
  "social_communication",
] as const;

export const DOMAIN_COLORS: Record<string, string> = Object.fromEntries(
  DOMAIN_IDS.map((id) => [id, `var(--study-domain-${id})`]),
);

export function domainColor(domainId: string): string | undefined {
  return DOMAIN_COLORS[domainId];
}
